import { BreakPointCondition, useBreakpointIf, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { mountAccount } from '../../../../store/customer/normalize';
import { FeatureToggle, useUnleashFlags } from '../../../../utils/useUnleashFlags';
import { handleExportNewOrder } from '../../../OrdersHistory/Container/components/OrderHistoryItem/constants';
import { OrderAccordion } from '../OrderAccordion';
import { OrderHeaderDetails } from '../OrderHeaderDetails';
import { OrderPrincipalCardDetails } from '../OrderPrincipalCardDetails';
import { OrderStatusesSequence } from '../OrderStatusesSequence';

import {
  OrderDetailsProps,
  getAssetsColumns,
  getDetailsItems,
  getPreDetailsItems,
  getNotificationChannels,
  getExtraDetailsItems,
} from './constants';

export const OrderDetails = ({ handleCloseDetails, item }: OrderDetailsProps) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const { b2bShowOrderHistoryEquityActions } = useUnleashFlags(
    FeatureToggle.OrderHistoryEquityActions
  );

  const isReferencedByBasket =
    !!item.basketDetail &&
    !!item.basketDetail.basketAdvisorOrderId &&
    !!item.basketDetail.basketAdvisorOrderHash;

  const onBasketPress = () => {
    if (isReferencedByBasket) {
      navigate('BatchTicketDetail', {
        basketAdvisorOrderId: item.basketDetail.basketAdvisorOrderId,
      });
    }
  };

  return (
    <VStack
      flex={1}
      padding={Spacing['inline.xxs']}
      space={Spacing['stack.xxxs']}
      bgColor={Color['neutral.white']}
      overflowY="scroll">
      <OrderHeaderDetails
        onClose={handleCloseDetails}
        isBasket={false}
        lastUpdateDate={Utils.Mask.DateFormat(item.updateDate, 'dd/MM/yyyy HH:mm:ss')}
        onExportPress={() => handleExportNewOrder(item)}
        orderHasBasket={isReferencedByBasket}
        onBasketPress={onBasketPress}
        orderName={`${item.orderHash ? `#${item.orderHash}` : item.orderId}`}
        isMobile={isMobile}
      />
      <OrderPrincipalCardDetails
        orderName={item.orderHash || item.orderId}
        notificationChannels={getNotificationChannels(item)}
        orderDate={Utils.Mask.DateFormat(item.orderDate, 'dd/MM/yyyy HH:mm')}
        requestedAmount={Utils.Mask.Money(item.requestedAmount)}
        orderHasBasket={isReferencedByBasket}
        onBasketPress={onBasketPress}
        onExportPress={() => handleExportNewOrder(item)}
        isMobile={isMobile}
        requestUserFullName={item?.requestUserFullName}
      />
      <OrderStatusesSequence isMobile={isMobile} />
      <OrderAccordion
        isMobile={isMobile}
        sideDescription={item.sideDescription}
        clientAccountLabel="Conta de Custódia"
        clientAccount={mountAccount(item.account.pnpAccountNumber, item.account.pnpAccountDigit)}
        clientName={item.customer.customerName || '--'}
        lastUpdateDate={Utils.Mask.DateFormat(item.updateDate, 'dd/MM/yyyy HH:mm:ss')}
        totalRequestedAmount={Utils.Mask.Money(item.requestedAmount)}
        assets={[
          {
            requestedAmount: Utils.Mask.Money(item.requestedAmount),
            orders: [item],
            assetTypeLabel: item.marketType || 'Desconhecido',
            assetExtraInfoGetter: (order) =>
              getExtraDetailsItems(order, b2bShowOrderHistoryEquityActions),
            assetInfoGetter: (order) => getDetailsItems(order, b2bShowOrderHistoryEquityActions),
            assetPreInfoGetter: (order) => getPreDetailsItems(order),
            assetInfoColumnsGetter: (order) => getAssetsColumns(order),
          },
        ]}
      />
    </VStack>
  );
};
